export interface Teacher {
    id: string;
    user_id: string;
    teacher_id: string;
    nip: string;
    specialization?: string;
    phone?: string;
    address?: string;
    birth_date?: string;
    qualification?: string;
    hire_date?: string;
    gender?: string;
    is_homeroom: boolean;
    homeroom_teacher_id?: string;
    user: {
        id: string;
        name: string;
        email: string;
    };
    homeroomClass?: {
        id: string;
        name: string;
        class_code: string;
    };
    created_at: string;
    updated_at: string;
}

export interface CreateTeacherData {
    name: string;
    email: string;
    nip: string;
    phone?: string;
    address?: string;
    gender?: string;
    birth_date?: string;
    qualification?: string;
    specialization?: string;
    hire_date?: string;
    is_homeroom?: boolean;
}

export interface UpdateTeacherData {
    name?: string;
    email?: string;
    nip?: string;
    phone?: string;
    address?: string;
    gender?: string;
    birth_date?: string;
    qualification?: string;
    specialization?: string;
    hire_date?: string;
    is_homeroom?: boolean;
}

export interface TeacherFilters {
    is_homeroom?: boolean;
    specialization?: string;
    search?: string;
    status?: string;
    page?: number;
    per_page?: number;
}

export interface TeacherListResponse {
    success: boolean;
    message: string;
    data: {
        items: Teacher[];
        meta: {
            current_page: number;
            last_page: number;
            per_page: number;
            total: number;
            from: number;
            to: number;
        };
    };
}

export interface TeacherResponse {
    success: boolean;
    message: string;
    data: Teacher;
}

import api from "./axios";

export const teacherApi = {
    async getAll(filters: TeacherFilters = {}): Promise<TeacherListResponse> {
        const response = await api.get("/v1/teachers", { params: filters });
        return response.data;
    },

    async getById(id: string): Promise<TeacherResponse> {
        const response = await api.get(`/v1/teachers/${id}`);
        return response.data;
    },

    async create(data: CreateTeacherData): Promise<TeacherResponse> {
        const response = await api.post("/v1/teachers", data);
        return response.data;
    },

    async update(
        id: string,
        data: UpdateTeacherData,
    ): Promise<TeacherResponse> {
        const response = await api.put(`/v1/teachers/${id}`, data);
        return response.data;
    },

    async delete(id: string): Promise<{ success: boolean; message: string }> {
        await api.delete(`/v1/teachers/${id}`);
        return { success: true, message: "Teacher deleted successfully" };
    },

    async getHomeroomTeachers(): Promise<{
        success: boolean;
        message: string;
        data: Teacher[];
    }> {
        const response = await api.get("/v1/teachers/homeroom");
        return response.data;
    },

    async getBySubject(
        subjectId: string,
    ): Promise<{ success: boolean; message: string; data: Teacher[] }> {
        const response = await api.get(`/v1/teachers/subject/${subjectId}`);
        return response.data;
    },

    async assignHomeroom(
        teacherId: string,
        classId: string,
    ): Promise<TeacherResponse> {
        const response = await api.put(
            `/v1/teachers/${teacherId}/assign-homeroom`,
            { class_id: classId },
        );
        return response.data;
    },

    async removeHomeroom(teacherId: string): Promise<TeacherResponse> {
        const response = await api.put(
            `/v1/teachers/${teacherId}/remove-homeroom`,
        );
        return response.data;
    },
};

export default teacherApi;
